import React, { useState } from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import './CookieConsent.css';

const CookieConsent = ({ onAcceptAll, onRejectNonEssential, onSavePreferences, onClose }) => {
  const { t } = useLanguage();
  const [showDetails, setShowDetails] = useState(false);
  const [preferences, setPreferences] = useState({
    essential: true, // Essential cookies cannot be disabled
    functional: true,
    analytics: true,
    marketing: false
  });

  const handlePreferenceChange = (category) => {
    setPreferences(prev => ({
      ...prev,
      [category]: !prev[category]
    }));
  };

  const handleSavePreferences = () => {
    onSavePreferences(preferences);
  };

  return (
    <div className="cookie-consent-container">
      <div className="cookie-consent-modal">
        <div className="cookie-consent-content">
          <h3>{t('cookie.title')}</h3>
          <p>{t('cookie.intro')}</p>
          
          {!showDetails ? (
            <div className="cookie-consent-buttons">
              <button className="btn btn-secondary" onClick={() => setShowDetails(true)}>
                {t('cookie.customize')}
              </button>
              <button className="btn btn-outline" onClick={onRejectNonEssential}>
                {t('cookie.essentialOnly')}
              </button>
              <button className="btn btn-primary" onClick={onAcceptAll}>
                {t('cookie.acceptAll')}
              </button>
            </div>
          ) : (
            <div className="cookie-consent-preferences">
              <div className="cookie-preference-item">
                <div className="preference-info">
                  <h4>{t('cookie.essentialTitle')}</h4>
                  <p>{t('cookie.essentialBody')}</p>
                </div>
                <input 
                  type="checkbox" 
                  checked={preferences.essential} 
                  disabled 
                />
              </div>
              
              <div className="cookie-preference-item">
                <div className="preference-info">
                  <h4>{t('cookie.functionalTitle')}</h4>
                  <p>{t('cookie.functionalBody')}</p>
                </div>
                <input 
                  type="checkbox" 
                  checked={preferences.functional} 
                  onChange={() => handlePreferenceChange('functional')}
                />
              </div>
              
              <div className="cookie-preference-item">
                <div className="preference-info">
                  <h4>{t('cookie.analyticsTitle')}</h4>
                  <p>{t('cookie.analyticsBody')}</p>
                </div>
                <input 
                  type="checkbox" 
                  checked={preferences.analytics} 
                  onChange={() => handlePreferenceChange('analytics')}
                />
              </div>
              
              <div className="cookie-preference-item">
                <div className="preference-info">
                  <h4>{t('cookie.marketingTitle')}</h4>
                  <p>{t('cookie.marketingBody')}</p>
                </div>
                <input 
                  type="checkbox" 
                  checked={preferences.marketing} 
                  onChange={() => handlePreferenceChange('marketing')}
                />
              </div>
              
              <div className="cookie-consent-buttons">
                <button className="btn btn-secondary" onClick={() => setShowDetails(false)}>
                  {t('common.back')}
                </button>
                <button className="btn btn-primary" onClick={handleSavePreferences}>
                  {t('cookie.save')}
                </button>
              </div>
            </div>
          )}
          
          <div className="cookie-consent-footer">
            <p>
              <a href="/privacy" onClick={(e) => {e.preventDefault(); onClose(); window.location.href = '/privacy';}}>
                {t('cookie.policy')}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent; 
